import { render } from "./Book.vue?vue&type=template&id=7b06c1dc&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"

import "./Book.vue?vue&type=style&index=0&id=7b06c1dc&scoped=true&lang=css"

import exportComponent from "E:\\学习资料\\项目\\Vue-Springboot-Library-main\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b06c1dc"]])

export default __exports__